export const FETCH_GENRES = 'FETCH_GENRES'
export const FETCH_GENRES_REQUEST = 'FETCH_GENRES_REQUEST'
export const FETCH_GENRES_SUCCESS = 'FETCH_GENRES_SUCCESS'